import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import config from "../config";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <Container fluid className="footer">
        <Row>
          <Col md="4" className="footer-copywright">
            <h3>Designed and Developed by {config.owner.name}</h3>
          </Col>
          <Col md="4" className="footer-copywright">
            <h3>Copyright &copy; {year} {config.owner.name}</h3>
          </Col>
          <Col md="4" className="footer-body">
            <ul className="footer-icons" aria-label="Social media links">
              <li className="social-icons">
                <a
                  href={config.github.profileUrl}
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub profile"
                >
                  <AiFillGithub aria-hidden="true" />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href={config.owner.linkedinUrl}
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn profile"
                >
                  <FaLinkedinIn aria-hidden="true" />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
